import { render } from "./history-emp-deps.vue?vue&type=template&id=f2a61c2c"
import script from "./history-emp-deps.vue?vue&type=script&setup=true&lang=js"
export * from "./history-emp-deps.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/history/history-card/components/history-emp-deps.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f2a61c2c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f2a61c2c', __exports__)) {
    api.reload('f2a61c2c', __exports__)
  }
  
  module.hot.accept("./history-emp-deps.vue?vue&type=template&id=f2a61c2c", () => {
    api.rerender('f2a61c2c', render)
  })

}


export default __exports__